import React from "react";
import styled from "styled-components";
import TextView from "../../../components/TextView";
import { colors } from "../../../utils";

const Container = styled.div`
  border-left: 3px solid ${({ color }) => color};
  padding: 10px;
  width: max-content;
  margin-right: 20px;
`;

export default function PercentageCard({ percentage, text, color }) {
  return (
    <Container color={color}>
      <TextView
        variant="largeTitle"
        style={{ fontWeight: 500, marginBottom: 5 }}
      >
        {percentage}
      </TextView>
      <TextView variant="subtitle" style={{ color: colors.lightGrey }}>
        {text}
      </TextView>
    </Container>
  );
}
